<li
    class="menu-item"
    [class.withSub]="isSubmenuInactive || (isActiveLink && submenu)"
    [class.active]="isActiveLink && !ignoreActive"
    [class.sub]="isSubItem || isSmall"
    [class.minify]="minify"
    [class.inverse]="inverseMode"
>
    <a
        *ngIf="!externalUrl"
        class="menu-item-link"
        [class.sub]="isSubItem || isSmall"
        [class.small]="isSmall"
        [class.inverse]="inverseMode"
        [class.active]="isActiveLink && !ignoreActive"
        (click)="onNavigationClick($event)"
    >
        <div *ngTemplateOutlet="linkContent"></div>
    </a>
    <a
        *ngIf="externalUrl"
        class="menu-item-link"
        [class.sub]="isSubItem || isSmall"
        [class.small]="isSmall"
        [class.inverse]="inverseMode"
        [href]="link"
    >
        <ng-container *ngTemplateOutlet="linkContent"></ng-container>
    </a>
    <div *ngIf="isSubmenuVisible" class="submenu">
        <ng-container *ngTemplateOutlet="submenu"></ng-container>
    </div>
</li>

<ng-template #linkContent>
    <div class="menu-item-title">
        <div class="menu-item-icon">
            <i *ngIf="icon" [class]="icon"></i>
            <div *ngIf="!icon" class="menu-item-icon-mock">{{pseudoIcon}}</div>
        </div>
        <div class="menu-item-content">
            <div class="m-1"></div>
            <p *ngIf="titleItem">{{titleItem}}</p>
            <ng-content></ng-content>
        </div>
    </div>
    <div *ngIf="submenu && !minify">
        <div class="menu-item-arrow">
            <i [class]="isSubmenuVisible ? 'icon-i-shevron-up' : 'icon-i-shevron-down'"></i>
        </div>
    </div>
</ng-template>